export default __webpack_public_path__ + "static/media/Inspiration_Senior.2832664f.jpg";